import Reveal from '@/components/base/Reveal';
import { welcomeVideo } from '@/mocks/homeData';

export default function WelcomeSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <Reveal>
            <div className="w-full">
              <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-primary-600">
                <span className="w-6 h-px bg-primary-500"></span>
                Welcome
              </span>
              <h2 className="font-heading mt-3 text-2xl md:text-4xl font-semibold leading-tight text-foreground-950">
                Welcome to Best Research Pharma
              </h2>
              <p className="mt-5 text-sm md:text-base leading-relaxed text-foreground-600">
                Best Research Pharma is one of the fastest growing Ayurvedic medicine manufacturers and suppliers from
                Madurai, Tamil Nadu. We are engaged in the manufacturing and distribution of Ayurvedic medicines across
                India. Our team is the perfect blend of professionals and experienced hands, resulting in new molecules
                and new formulations shaped around the demands of the market.
              </p>
              <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
                As Ayurvedic medicine suppliers, we firmly believe that manufacturing and distributing Ayurvedic
                medicines is not just a trade but an art, and we invest our hearts and minds equally into it. Since our
                establishment, we have grown into one of the leading Ayurvedic capsule manufacturers in India.
              </p>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div className="flex items-center gap-3 p-3 rounded-lg bg-secondary-50 border border-secondary-100">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-500 text-background-50 shrink-0">
                    <i className="ri-shield-check-line text-lg"></i>
                  </span>
                  <span className="text-sm font-semibold text-secondary-900">GMP Quality Standards</span>
                </div>
                <div className="flex items-center gap-3 p-3 rounded-lg bg-accent-50 border border-accent-100">
                  <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-500 text-primary-950 shrink-0">
                    <i className="ri-plant-line text-lg"></i>
                  </span>
                  <span className="text-sm font-semibold text-accent-900">Pure Herbal Ingredients</span>
                </div>
              </div>

              <a
                href="#categories"
                className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                Explore Our Range
                <i className="ri-arrow-right-line text-base"></i>
              </a>
            </div>
          </Reveal>

          <Reveal delay={120}>
            <div className="w-full">
              <div className="relative w-full rounded-2xl overflow-hidden border border-background-200 bg-primary-950 aspect-video">
                <iframe
                  src={welcomeVideo}
                  title="Best Research Pharma promotional video"
                  className="w-full h-full"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

              <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3 rounded-2xl border border-background-200 bg-background-100/70 p-4">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0">
                    <i className="ri-award-line text-lg"></i>
                  </span>
                  <div>
                    <p className="font-heading text-base font-semibold text-foreground-950">31+ Years of Trust</p>
                    <p className="text-xs text-foreground-600">Serving authentic Ayurveda since our founding.</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 rounded-2xl border border-background-200 bg-background-100/70 p-4">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
                    <i className="ri-medal-line text-lg"></i>
                  </span>
                  <div>
                    <p className="font-heading text-base font-semibold text-foreground-950">RDS Pain Balm®</p>
                    <p className="text-xs text-foreground-600">Our registered trade mark product.</p>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}